export function SendMessage(message) {
  return (          
         fetch("https://wa.coresol.co/send-quote", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",            
          },
          body: new URLSearchParams({message }).toString(),
        })
  );   
}